import { Title, Text, Stack } from '@mantine/core';
import { useAuth } from '../lib/auth';

export default function Dashboard() {
  const { admin } = useAuth();
  return (
    <Stack gap="sm">
      <Title order={2}>Welcome, {admin?.name ?? admin?.username}</Title>
      <Text c="dimmed">Select a section from the sidebar to get started.</Text>
    </Stack>
  );
}
